import React, { useState } from "react";
import { useGoogleLogin } from "@react-oauth/google";
import { useNavigate } from "react-router-dom";
import { Button, message, Alert } from "antd";
import { GoogleOutlined } from "@ant-design/icons";
import { useAuth } from "../../context/AuthContext";
import { authApi } from "../../services/api";

const LOGIN_SCOPE = "openid email profile";

export default function LoginPage() {
  const navigate = useNavigate();
  const { login, isAuthenticated } = useAuth();
  const [notRegistered, setNotRegistered] = useState(false);
  const [loading, setLoading] = useState(false);

  if (isAuthenticated) {
    navigate("/sq-ai", { replace: true });
    return null;
  }

  const startLogin = useGoogleLogin({
    flow: "auth-code",
    scope: LOGIN_SCOPE,
    onSuccess: async ({ code }) => {
      setLoading(true);
      try {
        setNotRegistered(false);
        const res = await authApi.googleLogin(code);
        login(res.data.token, res.data.user, res.data.permissions, res.data.globalPermissions || []);
        navigate("/sq-ai");
      } catch (err) {
        const errorData = err.response?.data;
        if (errorData?.error === "not_registered") {
          setNotRegistered(true);
        } else {
          const msg = errorData?.error || "Login failed";
          message.error(msg);
        }
      } finally {
        setLoading(false);
      }
    },
    onError: () => message.error("Google login failed"),
  });

  return (
    <div className="login-page">
      <div className="login-card">
        <div className="login-logo">
          <span>SQ</span>
        </div>
        <h1 className="login-title">SafetyQube Admin</h1>
        <p className="login-subtitle">Sign in with your organization account</p>

        {notRegistered && (
          <Alert
            type="warning"
            showIcon
            message="Account Not Registered"
            description="Your account is not registered in the system. Please ask an administrator to add you."
            className="mb-4 text-left"
          />
        )}

        <div className="flex justify-center">
          <Button
            type="primary"
            size="large"
            icon={<GoogleOutlined />}
            loading={loading}
            onClick={() => startLogin()}
            className="w-[280px]"
          >
            Sign in with Google
          </Button>
        </div>
      </div>
    </div>
  );
}
